import { render, staticRenderFns } from "./updateWithdrawal.vue?vue&type=template&id=2920ea99&"
import script from "./updateWithdrawal.vue?vue&type=script&lang=js&"
export * from "./updateWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports